import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import { ModelAttributeConfig } from '@zipari/shared-ds-util-configuration';
import {
  SidePanelConfig,
  SidePanelErrors,
  ActiveClaim,
} from './side-panel.constants';
import { SidePanel } from './side-panel.model';
import { checkInputsForText } from '../../design-system.helper';

@Component({
  selector: 'mp-side-panel',
  templateUrl: './side-panel.component.html',
  styleUrls: ['./side-panel.component.scss'],
})
export class SidePanelComponent implements OnInit, OnChanges {
  @Input() config: SidePanelConfig;

  @Input() context: any; // for attribute lists...normally "Member"
  @Input() errors: SidePanelErrors;
  @Input() labelsList: string[];
  @Input() notes: string;
  @Input() activeClaim: ActiveClaim;
  @Output() addNewButtonClicked: EventEmitter<string> = new EventEmitter();
  @Output() editButtonClicked: EventEmitter<string> = new EventEmitter();
  @Output() resourceItemClicked: EventEmitter<ModelAttributeConfig> =
    new EventEmitter();
  @Output() customItemClicked: EventEmitter<string> = new EventEmitter();

  sidePanel: SidePanel;

  handleResourceClicked(evt: ModelAttributeConfig) {
    this.resourceItemClicked.emit(evt);
  }

  handleCustomAction(evt: string) {
    this.customItemClicked.emit(evt);
  }

  ngOnInit(): void {
    const [config, context, errors, labelsList, notes, activeClaim] =
      checkInputsForText([
        this.config,
        this.context,
        this.errors,
        this.labelsList,
        this.notes,
        this.activeClaim,
      ]);

    this.config = config as SidePanelConfig;
    this.context = context;
    this.errors = errors as SidePanelErrors;
    this.labelsList = labelsList as string[];
    this.notes = notes as string;
    this.activeClaim = activeClaim as ActiveClaim;

    this.sidePanel = new SidePanel(
      this.config,
      this.labelsList,
      this.notes,
      this.activeClaim,
    );
  }

  ngOnChanges(): void {
    this.sidePanel = new SidePanel(
      this.config,
      this.labelsList,
      this.notes,
      this.activeClaim,
    );
  }
}
